<template>
  <div class="row footer-position-bottom-stikcy mt-3" style="background:white;border-radius:4px;">
    <!--  
    <footer class="footer pt-3 pb-3">
      <div class="container-fluid">
        <div class="row align-items-center justify-content-lg-between">
          <div class="col-lg-6 mb-lg-0 mb-4">
            <div class="copyright text-center text-sm text-muted text-lg-left">
              <a href="https://pertaminaretail.com" class="font-weight-bold" target="_blank">Pertamina Retail</a>
            </div>
          </div>
          <div class="col-lg-6">
            <ul class="nav nav-footer justify-content-center justify-content-lg-end">
              <li class="nav-item">
                <a href="https://pertaminaretail.com" class="nav-link text-muted" target="_blank">About</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    -->
  </div>
</template>


<script>

export default{
    name:'Footer',
    setup() {
        
    },
}
</script>
<style scoped>
.footer{ display: table; width:100%; position: relative;}

.footer-position-bottom-stikcy {
	position: sticky !important;
	z-index: 30; /**1020 */
	left: auto;
	right: 0;
	bottom: 0%!important;
}

</style>